const configList = {
  // 活动状态
  activityStatus: [
    { value: 1, label: '已参加' },
    { value: 2, label: '已签到' },
    { value: 3, label: '已购车' }
  ],
  // 审核状态
  auditState: [
    { label: '待审核', value: 0, class: 'c-warning' },
    { label: '审核失败', value: 1, class: 'c-danger' },
    { label: '审核成功', value: 2, class: 'c-success' }
  ]
};

export const getConfigData = (type) => {
  return configList[type] || [];
};

export const filterConfig = (type) => {
  const map = new Map();
  getConfigData(type).forEach(item => {
    map.set(item.value, item);
  });
  return Object.fromEntries(map);
};
